module.exports = __webpack_public_path__ + "img/lab.691dcbc9.png";